import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { GetTokenBindingModel } from 'src/app/api/models/base.model';
import { WebBookingService } from 'src/app/api/services/web-booking.service';
import { AppConstants } from 'src/app/app.constants';
import { DateService } from 'src/app/services/date.service';
import { StorageService } from 'src/app/services/storage.service';
import { StringService } from 'src/app/services/string.service';

@Component({
  selector: 'app-password-dialog',
  templateUrl: './password-dialog.component.html',
  styleUrls: ['./password-dialog.component.scss']
})
export class PasswordDialogComponent implements OnInit {

  password: string;
  
  constructor(
    public dialogRef: MatDialogRef<PasswordDialogComponent>,
    public stringService: StringService,
    public webBookingService: WebBookingService,
    public dateService: DateService,
    public spinner: NgxSpinnerService,
    public storageService: StorageService,
    public toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  ngOnInit(): void {

  }

  getToken(): void {
    const model: GetTokenBindingModel =
    {
      username: this.data.email,
      email: this.data.email,
      password: this.password,
      grand_type: 'password'
    };

    this.spinner.show();
    this.webBookingService.GetToken(model)
      .subscribe(
        data => {
          data.created_date = this.dateService.formatDateTime(new Date());
          this.storageService.setItem(AppConstants.Token, JSON.stringify(data));
          this.data.action = 1;
          this.spinner.hide();
          this.dialogRef.close(this.data);
        },
        error => {
          this.spinner.hide();
          this.showErrorMessage(error);
        });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  showErrorMessage(data: any): void {
    const message = this.getBadRequest(data);
    this.toastr.error(message, 'Error', { timeOut: 3000 });
  }
  
  getBadRequest(data: any): string {
    let message = '';
    if (data != null && data._body != null) {
      const body = JSON.parse(data._body);
      if (body.message != null) { message = body.message; }
      if (body.error_description != null) { message = body.error_description; }
    }
    else if (data.error != null && data.error !== undefined) {
      if (data.error.message != null) { message = data.error.message; }
      if (data.error.error_description != null) { message = data.error.error_description; }
    }
    else {
      message = data;
    }
    return message;
  }
}
